/* NUANSE: oferta (spec 11_OFERTA_CRO_SPEC). Bundles no produto, mensagem de presente, cartão do significado,
   carrinho com progresso, celebração de patamar, completa o conjunto, estados do saldo.
   Tudo calculado com os preços reais e com as mesmas regras da Shopify (Leva 2 −15%, Leva 3 −20%, SALDO5 5 € a partir de 40 €, portes grátis a partir de 59 €).
   ponytail: carrinho em localStorage (o mesmo do ficheiro principal); quando houver produtos reais, trocar por /cart/add.js. */
(function () {
  "use strict";
  var reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
  var A = function () {
    return window.NZAPP;
  };
  var money = NZL.money;
  var esc = function (s) {
    return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c];
    });
  };

  /* ---------- símbolos, pares e significado ---------- */
  var SYMBOL = [
    ["colibri", /humming|colibri/i],
    ["abraco-gato", /cat-hug|abraco-ao-gato|abraço ao gato|cat hug/i],
    [
      "abraco-cao",
      /dog-hug|abraco-ao-cao|gold-dog-memorial|dog-mom|abraço ao cão|dog embrace|dog hug/i,
    ],
    ["pata", /paw|pata|bone/i],
    ["gato", /\bcat\b|gato|kitten/i],
    ["cao", /\bdog\b|cão|puppy/i],
    ["borboleta", /butterfl|borboleta/i],
    ["lua", /moon|lua|opal/i],
  ];
  var SETS = {
    "colar-colibri-colorido": ["brincos-colibri", "colar-colibri-em-cupula"],
    "brincos-colibri": ["colar-colibri-colorido", "colar-colibri-em-cupula"],
    "colar-colibri-em-cupula": ["brincos-colibri", "colar-colibri-colorido"],
    // o brincos-abraco-bicolor é um GATO (ver foto): o par do cão são os brincos nc-1369
    "colar-abraco-ao-cao": ["brincos-abraco-dois-tons-nc-1369"],
    "colar-abraco-dourado-nc-1367": ["brincos-abraco-dois-tons-nc-1369"],
    "brincos-abraco-dois-tons-nc-1369": ["colar-abraco-ao-cao"],
    "anel-abraco-ao-cao": ["colar-abraco-ao-gato", "brincos-abraco-ao-gato"],
    "brincos-abraco-bicolor": ["colar-abraco-ao-gato", "anel-gato"],
    "colar-abraco-ao-gato": ["brincos-abraco-ao-gato", "anel-abraco-ao-cao"],
    "brincos-abraco-ao-gato": ["colar-abraco-ao-gato", "anel-gato"],
    "colar-pedra-da-lua": ["brincos-dente-de-leao", "colar-gota-de-opala"],
  };

  var MEANING = {
    "abraco-cao": [
      "Há amores que não cabem numa fotografia.",
      "O lugar dele no sofá, o som das patas no corredor. Este pendente guarda esse abraço junto ao teu peito, para os dias em que a saudade aperta e para os dias em que só queres sorrir.",
      "O amor de um animal não acaba. Muda de lugar: passa a viver connosco.",
      "Para ti, se ele está ao teu lado ou se já partiu e continua contigo.",
    ],
    "abraco-gato": [
      "Há amores que não cabem numa fotografia.",
      "O ronronar no colo, o lugar ao sol na janela. Este pendente guarda esse abraço junto ao teu peito, todos os dias.",
      "O amor de um animal não acaba. Muda de lugar: passa a viver connosco.",
      "Para ti, se ele está ao teu lado ou se já partiu e continua contigo.",
    ],
    colibri: [
      "Diz-se que quando um colibri aparece, alguém que amamos está perto.",
      "Uma ave pequena que nunca para de bater as asas: é por isso que tantas mulheres o usam pela mãe, pela avó, por quem já não está à mesa ao domingo.",
      "O colibri lembra-nos que a alegria é leve e que quem amamos nunca está longe.",
      "Para ti, ou para quem precisa de saber que não está sozinha.",
    ],
    borboleta: [
      "Ninguém sai de uma fase difícil igual a como entrou.",
      "A borboleta é o símbolo de quem mudou e ficou mais bonita por isso. Uma reforma, uma doença ultrapassada, um recomeço.",
      "Tudo o que muda em nós também nos faz voar.",
      "Para quem está a recomeçar.",
    ],
    lua: [
      "Para a mulher que dá tudo a todos e raramente compra alguma coisa para si.",
      "A lua é o símbolo dos ciclos, da intuição e do tempo que é só nosso. Esta é a peça que mereces sem precisares de motivo.",
      "Há luz que só se vê quando paramos um bocadinho.",
      "Para ti. Desta vez, para ti.",
    ],
    pata: [
      "Deixou pegadas no chão da cozinha e no teu coração.",
      "Uma pata pequena, discreta para usar todos os dias, cheia de significado para quem sabe.",
      "Há pegadas que nunca se apagam.",
      "Para quem tem, ou teve, um amigo de quatro patas.",
    ],
    gato: [
      "Para quem sabe que a casa só fica completa com um gato.",
      "Uma peça delicada, com o mistério e a ternura de quem dorme ao teu lado.",
      "Os gatos escolhem quem amam. E escolheram-te a ti.",
      "Para ti, ou para a amiga que fala dos gatos como se fossem filhos.",
    ],
    cao: [
      "Ninguém te espera à porta como ele.",
      "Uma peça para levar contigo o amigo mais fiel que alguma vez tiveste.",
      "Amor de cão não se explica. Sente-se.",
      "Para quem tem, ou teve, um amigo de quatro patas.",
    ],
    _: [
      "Há peças que dizem o que as palavras não conseguem.",
      "Escolhemos cada joia pelo que significa, para a usares todos os dias ou a ofereceres a quem importa.",
      "Algumas coisas pequenas guardam as maiores histórias.",
      "Para ti, ou para quem tem um lugar no teu coração.",
    ],
  };
  if (NZL.en) MEANING = {
    "abraco-cao": [
      "Some love doesn't fit in a photograph.",
      "His spot on the sofa, the sound of paws in the hallway. This pendant keeps that hug close to your heart, for the days you miss him most and the days you just want to smile.",
      "An animal's love doesn't end. It moves: it comes to live with us.",
      "For you, whether he's by your side or gone and still with you.",
    ],
    "abraco-gato": [
      "Some love doesn't fit in a photograph.",
      "The purring on your lap, the sunny spot by the window. This pendant keeps that hug close to your heart, every day.",
      "An animal's love doesn't end. It moves: it comes to live with us.",
      "For you, whether she's by your side or gone and still with you.",
    ],
    colibri: [
      "They say that when a hummingbird appears, someone we love is near.",
      "A tiny bird that never stops beating its wings: that's why so many women wear it for their mum, their nan, for whoever no longer sits at the Sunday table.",
      "The hummingbird reminds us that joy is light and the ones we love are never far.",
      "For you, or for someone who needs to know she's not alone.",
    ],
    borboleta: [
      "Nobody comes out of a hard time the same as they went in.",
      "The butterfly is the symbol of someone who has changed and grown more beautiful because of it. A retirement, an illness overcome, a fresh start.",
      "Everything that changes in us also helps us fly.",
      "For someone starting again.",
    ],
    lua: [
      "For the woman who gives everything to everyone and rarely buys anything for herself.",
      "The moon is the symbol of cycles, intuition and time that's just ours. This is the piece you deserve without needing a reason.",
      "Some light only shows when we stop for a moment.",
      "For you. This time, for you.",
    ],
    pata: [
      "Little paw prints on the kitchen floor and on your heart.",
      "A small paw, subtle enough to wear every day, full of meaning for those who know.",
      "Some paw prints never fade.",
      "For anyone who has, or had, a four-legged friend.",
    ],
    gato: [
      "For anyone who knows a home is only complete with a cat.",
      "A delicate piece, with the mystery and tenderness of the one who sleeps beside you.",
      "Cats choose who they love. And they chose you.",
      "For you, or for the friend who talks about her cats like they're her children.",
    ],
    cao: [
      "Nobody waits for you at the door like he does.",
      "A piece to carry the most loyal friend you've ever had.",
      "A dog's love can't be explained. It's felt.",
      "For anyone who has, or had, a four-legged friend.",
    ],
    _: [
      "Some pieces say what words can't.",
      "We choose every piece for what it means, to wear every day or to give to someone who matters.",
      "Some small things hold the biggest stories.",
      "For you, or for someone with a place in your heart.",
    ],
  };
  function symbolOf(h) {
    var p = A().P()[h],
      s = h + " " + (p ? p.t : "");
    for (var i = 0; i < SYMBOL.length; i++)
      if (SYMBOL[i][1].test(s)) return SYMBOL[i][0];
    return null;
  }
  function suggestions(h) {
    var P = A().P(),
      out = (SETS[h] || []).filter(function (x) {
        return P[x] && x !== h;
      });
    var sy = symbolOf(h);
    if (out.length < 2 && sy) {
      var type = /necklace|colar|pendant/i.test(P[h].t)
        ? "colar"
        : /earring|brinco/i.test(P[h].t)
          ? "brinco"
          : "outro";
      Object.keys(P).some(function (x) {
        if (x === h || out.indexOf(x) > -1 || symbolOf(x) !== sy) return false;
        var t2 = /necklace|colar|pendant/i.test(P[x].t)
          ? "colar"
          : /earring|brinco/i.test(P[x].t)
            ? "brinco"
            : "outro";
        if (t2 !== type && +P[x].p >= 15) out.push(x);
        return out.length >= 2;
      });
    }
    return out;
  }
  var CHAIN = { 14: 35, 16: 40, 18: 45, 20: 50, 22: 55, 24: 60 };
  function niceVal(v) {
    var m = String(v).match(/^(\d{2})\s*(?:"|inch|in|”|'')/i);
    return m && CHAIN[m[1]] ? CHAIN[m[1]] + " cm" : v;
  }
  function pctFor(n) {
    var D = window.NZD || [0, 0, 15, 20, 25]; return n >= 4 ? D[4] : n >= 3 ? D[3] : n === 2 ? D[2] : 0;
  }
  function priceLines(lines) {
    var P = A().P(),
      n = 0,
      sub = 0;
    lines.forEach(function (l) {
      n += l.q;
      sub += l.q * Number(P[l.h].v[l.vi] ? P[l.h].v[l.vi][1] : P[l.h].p);
    });
    var disc = (sub * pctFor(n)) / 100;
    return { n: n, sub: sub, disc: disc, total: sub - disc };
  }

  /* ---------- estado do presente ---------- */
  var GK = "nz-gift";
  function gift() {
    try {
      return JSON.parse(localStorage.getItem(GK)) || { on: false, msg: "" };
    } catch (e) {
      return { on: false, msg: "" };
    }
  }
  function setGift(g) {
    try {
      localStorage.setItem(GK, JSON.stringify(g));
    } catch (e) {}
  }
  // A mensagem vai para a encomenda como atributo "Mensagem" (/cart/update.js): aparece na encomenda na Shopify
  // e enviamo-la por email à cliente para reencaminhar. Não há cartão impresso nem email automático a quem recebe: o texto não promete isso.
  var GMAX = 200;
  function giftAttrs(g) {
    return { "Para oferecer": g.on ? "Sim" : "", Mensagem: (g.on && g.msg) || "", "Mensagem do cartão": "" };
  }
  var gT = null;
  function giftSync() {
    clearTimeout(gT);
    gT = setTimeout(function () {
      fetch("/cart/update.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ attributes: giftAttrs(gift()) }) }).catch(function () {});
    }, 500);
  }
  function left(n) {
    return L(n + " caracteres restantes", n + " characters left");
  }
  function giftBlock(id) {
    var g = gift();
    return (
      '<div class="gift" id="' + id + '"><label class="gift__chk"><input type="checkbox" data-gift-on ' + (g.on ? "checked" : "") + "> " +
      L("É para oferecer", "It's a gift") + "</label>" +
      '<div class="gift__body' + (g.on ? " open" : "") + '"><div>' +
      '<label class="gift__lbl" for="' + id + '-msg">' + L("A tua mensagem (opcional)", "Your message (optional)") + "</label>" +
      '<textarea id="' + id + '-msg" data-gift-msg maxlength="' + GMAX + '" rows="3" placeholder="' + L("Escreve aqui a tua mensagem", "Write your message here") + '">' + esc(g.msg) + "</textarea>" +
      '<div class="gift__meta"><span data-gift-left aria-live="polite">' + left(GMAX - g.msg.length) + "</span></div>" +
      '<div class="gift__chips">' +
      (NZL.en
        ? ["For the best mum in the world.", "They're still with us. A big hug.", "Because you deserve it. With love."]
        : ["Para a melhor mãe do mundo.", "Continuam connosco. Um abraço apertado.", "Porque mereces. Com amor."])
        .map(function (c) { return '<button type="button" data-gift-chip>' + c + "</button>"; })
        .join("") +
      "</div>" +
      '<p class="gift__note">' + L("A mensagem fica na encomenda e enviamos-ta por email para a reencaminhares.", "Your message is saved on the order and we email it to you to forward on.") + "</p>" +
      '<p class="gift__note">' + L("Escreve a morada de quem recebe no checkout e a encomenda segue diretamente para essa pessoa.", "Enter their address at checkout and the order goes straight to them.") + "</p>" +
      '<p class="gift__note">' + L("Sem preços nem fatura dentro da encomenda.", "No prices or invoice in the parcel.") + "</p>" +
      "</div></div></div>"
    );
  }
  window.NZGIFT = { attrs: function () { return giftAttrs(gift()); } };
  document.addEventListener("change", function (e) {
    if (e.target.matches("[data-gift-on]")) {
      var g = gift();
      g.on = e.target.checked;
      setGift(g);
      document.querySelectorAll("[data-gift-on]").forEach(function (c) {
        c.checked = g.on;
      });
      document.querySelectorAll(".gift__body").forEach(function (b) {
        b.classList.toggle("open", g.on);
      });
      giftSync();
    }
  });
  document.addEventListener("input", function (e) {
    if (e.target.matches("[data-gift-msg]")) {
      var g = gift();
      g.msg = e.target.value.slice(0, GMAX);
      setGift(g);
      document.querySelectorAll("[data-gift-msg]").forEach(function (t) { if (t !== e.target) t.value = g.msg; });
      document.querySelectorAll("[data-gift-left]").forEach(function (x) { x.textContent = left(GMAX - g.msg.length); });
      giftSync();
    }
  });
  // teclado aberto no campo da mensagem: a barra fixa sai do caminho
  document.addEventListener("focusin", function (e) { if (e.target.matches("[data-gift-msg]")) document.body.classList.add("nz-typing"); });
  document.addEventListener("focusout", function (e) { if (e.target.matches("[data-gift-msg]")) document.body.classList.remove("nz-typing"); });
  document.addEventListener("click", function (e) {
    var c = e.target.closest("[data-gift-chip]");
    if (!c) return;
    var box = c.closest(".gift"),
      ta = box.querySelector("[data-gift-msg]");
    ta.value = c.textContent;
    ta.dispatchEvent(new Event("input", { bubbles: true }));
    ta.focus();
  });

  /* ---------- página de produto ---------- */
  // medidas reais dos dados do produto (descrição e opções); sem medidas, não mostra nada
  function measures(info, p) {
    var out = [],
      d = (info.querySelector("#pdp-desc") || {}).textContent || "",
      m = d.match(/(?:(?:com |de )?cerca de |about |approx(?:imately|\.)? |≈ ?)?\d+(?:[.,]\d+)?\s?(?:mm|cm)\b(?:\s?x\s?\d+(?:[.,]\d+)?\s?(?:mm|cm))?/i);
    if (m) out.push([L("Medida", "Size"), m[0].replace(/^(com|de) /i, "").trim()]);
    (p.o || []).forEach(function (o) {
      var vs = o[1].filter(function (v) { return /\d\s?(cm|mm)\b/i.test(v); });
      if (vs.length && vs.length === o[1].length && vs.length <= 2) out.push([o[0], vs.join(" / ")]);
    });
    return out;
  }
  /* ---------- porque esta peça: 3 blocos, comparação honesta, separadores Medidas e materiais / Cuidados ---------- */
  var IC = {
    steel: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3l7 4v10l-7 4-7-4V7z M12 3v18 M5 7l7 4 7-4" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg>',
    ruler: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 8h18v8H3zM7 8v4M11 8v3M15 8v4M19 8v3" fill="none" stroke="currentColor" stroke-width="1.6"/></svg>',
    gift: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 8h18v4H3zM5 12v9h14v-9M12 8v13M12 8C10 4 6.5 4.5 7.5 7c.5 1 4.5 1 4.5 1zm0 0c2-4 5.5-3.5 4.5-1-.5 1-4.5 1-4.5 1z" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg>',
    heart: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20s-7-4.3-8.8-8.6C1.8 8 4 4.8 7.2 4.8c1.9 0 3.4 1 4.8 2.6 1.4-1.6 2.9-2.6 4.8-2.6 3.2 0 5.4 3.2 4 6.6C19 15.7 12 20 12 20z" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg>',
  };
  var SRC_RE = /,?\s*(segundo a ficha do fabricante|according to the maker'?s spec sheet)\.?/i;
  function specLines(info, p) {
    var MAT = /a[çc]o|inox|prata|925|liga|banho|ouro|zirc|p[ée]rola|esmalte|cm\b|mm\b|stainless|steel|silver|alloy|plat|gold|zircon|pearl|enamel/i;
    var out = [].slice.call(info.querySelectorAll("#pdp-desc li, #pdp-desc p"))
      .map(function (x) { return x.textContent.trim(); })
      .filter(function (t) { return t && MAT.test(t); })
      .map(function (t) { return t.replace(SRC_RE, ".").replace(/\.\.$/, "."); });
    measures(info, p).forEach(function (m) {
      if (!out.some(function (t) { return t.indexOf(m[1]) > -1; })) out.push(m[0] + ": " + m[1] + ".");
    });
    var sz = A().size ? A().size(info.closest(".pdp").querySelector("#gal").dataset.h) : "";
    if (sz) out.unshift(sz + ".");
    return out;
  }
  function material(info) {
    var d = ((info.querySelector("#pdp-desc") || {}).textContent || "");
    if (/prata 925|925 silver|sterling/i.test(d)) return L("Prata 925", "925 silver");
    if (/a[çc]o inoxid|stainless steel/i.test(d)) return L("Aço inoxidável", "Stainless steel");
    if (/liga de zinco|zinc alloy/i.test(d)) return L("Liga de zinco", "Zinc alloy");
    if (/acr[iíy]lic/i.test(d)) return L("Acrílico", "Acrylic");
    if (/\bliga\b|\balloy\b/i.test(d)) return L("Liga metálica", "Metal alloy");
    return null;
  }
  function why(info, p, M) {
    // comparação qualitativa, sem preços de outras lojas: só o que conseguimos sustentar
    var rows = [
      [L("Fabrico", "Making"), L("Já está feita, sem esperar por gravação", "Already made, no waiting for engraving"), L("Só é feita depois da encomenda", "Only made after you order")],
      [L("Devolução", "Returns"), L("30 dias, sem explicações", "30 days, no questions asked"), L("Muitas vezes sem devolução: a lei exclui peças personalizadas", "Often non-returnable: the law excludes personalised items")],
      [L("Leva 2 e Leva 3", "Buy 2 and Buy 3"), L("−15%, −20% e −25% (4+), automático no carrinho", "−15%, −20% and −25% (4+), automatic in your basket"), L("Depende da loja", "Depends on the shop")],
    ];
    var cmp = '<div class="cmp"><table><thead><tr><th scope="col"><span class="sr">' + L("Critério", "What") + '</span></th><th scope="col">NUANSE</th><th scope="col">' + L("Joia personalizada comum", "Typical personalised jewellery") + "</th></tr></thead><tbody>" +
      rows.map(function (r) { return '<tr><th scope="row">' + r[0] + "</th><td>" + r[1] + "</td><td>" + r[2] + "</td></tr>"; }).join("") +
      "</tbody></table></div>";
    var sp = specLines(info, p);
    var spec = sp.length
      ? '<p class="tabs__src">' + L("Segundo a ficha do fabricante:", "According to the maker's spec sheet:") + "</p><ul>" + sp.map(function (t) { return "<li>" + esc(t) + "</li>"; }).join("") + "</ul>"
      : "<p>" + L("A ficha do fabricante não indica medidas nem materiais para esta peça. Se precisares de saber, escreve para contacto@nuanse.online e confirmamos antes de comprares.", "The maker's spec sheet doesn't list measurements or materials for this piece. If you need to know, email contacto@nuanse.online and we'll check before you buy.") + "</p>";
    var care = "<ul>" + (NZL.en
      ? ["Take it off for the shower, the beach, the pool and the gym.", "Put on perfume and cream before you put it on.", "Store it dry, in a pouch or box, away from other pieces.", "Clean it with a soft, dry cloth."]
      : ["Tira-a no banho, na praia, na piscina e no ginásio.", "Põe o perfume e o creme antes de a colocares.", "Guarda-a seca, numa bolsa ou caixa, separada das outras peças.", "Limpa-a com um pano macio e seco."]).map(function (t) { return "<li>" + t + "</li>"; }).join("") + "</ul>";
    var acc = function (t, body) { return '<details class="acc"><summary>' + t + "</summary><div>" + body + "</div></details>"; };
    // frases da descrição (menos a 1.ª, que já está por baixo do título) entram em Medidas e materiais
    var dl = [].slice.call(info.querySelectorAll("#pdp-desc li, #pdp-desc p")).map(function (x) { return x.textContent.trim().replace(SRC_RE, ".").replace(/\.\.$/, "."); }).filter(Boolean).slice(1);
    var all = dl.slice();
    sp.forEach(function (t) { if (all.indexOf(t) < 0) all.push(t); });
    var med = (all.length ? "<ul>" + all.map(function (t) { return "<li>" + esc(t) + "</li>"; }).join("") + "</ul>" : spec) +
      '<h3 class="acc__h">' + L("Cuidados", "Care") + "</h3>" + care;
    var sig = info.querySelector("#acc-sig");
    if (sig) sig.insertAdjacentHTML("afterend", acc(L("Medidas e materiais", "Size and materials"), med));
    var ship = info.querySelector("#acc-ship"), fq = info.querySelector("#acc-faq");
    if (ship && fq) fq.parentNode.insertBefore(ship, fq);
    var fqd = info.querySelector("#acc-faq > div");
    if (fqd) fqd.insertAdjacentHTML("beforeend", '<h3 class="acc__h">' + L("NUANSE ou joia personalizada?", "NUANSE or a personalised piece?") + "</h3>" + cmp);
  }
  var PERSONA = ["caes", "gatos", "memoria"];
  function kind(t) {
    return /necklace|colar|pendant/i.test(t) ? "colar" : /earring|brinco|argola|hoop|stud/i.test(t) ? "brinco" : /ring\b|anel/i.test(t) ? "anel" : /bracelet|pulseira/i.test(t) ? "pulseira" : "outro";
  }
  function comboList(h) {
    var P = A().P(), p = P[h], k0 = kind(p.t), out = [];
    // persona mais específica primeiro (cão ou gato antes de memória): um colar de cão não sugere brincos de gato
    var tg = PERSONA.filter(function (t) { return (p.tg || []).indexOf(t) > -1; });
    // guarda contra etiquetas trocadas no catálogo (ex.: brincos de gato com a etiqueta caes)
    var clash = { caes: /gato|\bcat\b/i, gatos: /\bc[ãa]o\b|\bdog\b/i };
    var ok = function (x, t) { return x !== h && isMapped(x) && !included(h, x) && P[x] && out.indexOf(x) < 0 && (P[x].tg || []).indexOf(t) > -1 && !(clash[t] && clash[t].test(P[x].t)) && P[x].v.some(function (v) { return v[2]; }); };
    tg.forEach(function (t) {
      suggestions(h).forEach(function (x) { if (out.length < 3 && ok(x, t)) out.push(x); });
      // depois: mesma persona, outro tipo de peça primeiro (ordem da coleção = evidência)
      [true, false].forEach(function (other) {
        Object.keys(P).forEach(function (x) {
          if (out.length < 3 && ok(x, t) && other === (kind(P[x].t) !== k0)) out.push(x);
        });
      });
    });
    return out.slice(0, 3);
  }
  // conjunto por defeito: peças diferentes da mesma família (par definido em SETS, mesmo símbolo, mesma persona cão/gato),
  // outro tipo de peça primeiro, só peças com stock, preferindo nota real ≥ 4
  function isMapped(x) { return A().mapped ? A().mapped(x) : false; }
  // um conjunto (ex.: Conjunto Colibri: Colar e Brincos) já inclui esses tipos de peça do mesmo símbolo: não os sugerir outra vez
  function included(h, x) {
    var P = A().P(), p = P[h], q = P[x];
    if (!p || !q || !/conjunto|\bset\b/i.test(p.t + " " + h)) return false;
    var kinds = [];
    if (/colar|necklace|pendant/i.test(p.t)) kinds.push("colar");
    if (/brinco|earring/i.test(p.t)) kinds.push("brinco");
    if (/anel|\bring\b/i.test(p.t)) kinds.push("anel");
    if (/pulseira|bracelet/i.test(p.t)) kinds.push("pulseira");
    return kinds.indexOf(kind(q.t)) > -1;
  }
  var KORD = { colar: ["brinco", "anel", "pulseira", "colar"], brinco: ["colar", "anel", "pulseira", "brinco"], anel: ["colar", "brinco", "pulseira", "anel"], pulseira: ["colar", "brinco", "anel", "pulseira"], outro: ["colar", "brinco", "anel", "pulseira"] };
  function comboPicks(h) {
    var P = A().P(), p = P[h], k0 = kind(p.t), sy = symbolOf(h), rate = A().rate ? A().rate() : {}, ord = KORD[k0];
    var ptg = ["caes", "gatos"].filter(function (t) { return (p.tg || []).indexOf(t) > -1; });
    var clash = { caes: /gato|\bcat\b/i, gatos: /\bc[ãa]o\b|\bdog\b/i }, set = SETS[h] || [];
    var score = function (x) {
      var q = P[x], sc = 0, i = set.indexOf(x), r = rate[x], k = kind(q.t);
      if (i > -1) sc += 1000 - i * 100; // o par definido à mão manda, pela ordem da lista
      if (sy && symbolOf(x) === sy) sc += 50;
      if (ptg.some(function (t) { return (q.tg || []).indexOf(t) > -1; })) sc += 20;
      if (r && +r[0] >= 4) sc += 8; else if (r && +r[0] < 4) sc -= 5;
      sc += (3 - ord.indexOf(k)) * 6;
      if (k === k0) sc -= 15;
      return sc;
    };
    var cands = Object.keys(P).filter(function (x) {
      var q = P[x], s2 = q.t + " " + x;
      return x !== h && isMapped(x) && !included(h, x) && q.v.some(function (v) { return v[2]; }) && !/conjunto|\bset\b/i.test(s2) && !ptg.some(function (t) { return clash[t].test(s2); });
    }).map(function (x) { return [x, score(x)]; }).filter(function (a) { return a[1] >= 20; }).sort(function (a, b) { return b[1] - a[1]; });
    if (!cands.length) return [];
    var first = cands[0][0], kf = kind(P[first].t), rest = cands.slice(1);
    var second = rest.filter(function (a) { var k = kind(P[a[0]].t); return k !== k0 && k !== kf; })[0] || rest[0];
    return second ? [first, second[0]] : [first];
  }
  function comboMsg() {
    var n = A().cartTotals().n;
    return n >= 3
      ? L("Junto ✓ Já tens " + n + " peças: conta para o Leva 3 (−20%).", "Added ✓ You have " + n + " pieces: it counts for Buy 3 (−20%).")
      : n === 2
        ? L("Junto ✓ Já tens 2 peças: conta para o Leva 2 (−15%).", "Added ✓ You have 2 pieces: it counts for Buy 2 (−15%).")
        : L("Junto ✓ Conta para o Leva 2: junta mais 1 peça e ficas com −15%.", "Added ✓ It counts for Buy 2: add 1 more piece for −15%.");
  }
  function combo(h, info) {
    var P = A().P(), hs = comboList(h);
    if (hs.length < 2) return;
    var html = '<section class="combo" aria-label="' + L("Combina com", "Goes well with") + '"><h2 class="combo__h">' + L("Combina com", "Goes well with") + "</h2>" +
      '<p class="combo__s">' + L("Cada peça que juntas conta para o Leva 2 (−15%) e o Leva 3 (−20%).", "Every piece you add counts towards Buy 2 (−15%) and Buy 3 (−20%).") + "</p>" +
      hs.map(function (x) {
        var q = P[x], one = q.v.length === 1;
        return '<div class="combo__i"><a href="/products/' + x + '" data-link><img src="' + A().img(q.i[0], 160) + '" alt="" loading="lazy"></a>' +
          '<div class="combo__t"><a href="/products/' + x + '" data-link>' + esc(q.t) + "</a><span>" + money(q.p) + "</span></div>" +
          (one ? '<button type="button" class="combo__b" data-combo="' + x + '">+ ' + L("Juntar", "Add") + "</button>"
            : '<a class="combo__b" href="/products/' + x + '" data-link>' + L("Escolher", "Choose") + "</a>") +
          "</div>";
      }).join("") +
      '<p class="combo__msg" aria-live="polite" hidden></p></section>';
    var anchor = info.querySelector("#pdp-desc") || document.getElementById("atc");
    anchor.insertAdjacentHTML("afterend", html);
    var sec = info.querySelector(".combo");
    sec.addEventListener("click", function (e) {
      var b = e.target.closest("[data-combo]");
      if (!b || b.disabled) return;
      b.disabled = true;
      A().addLines([{ h: b.dataset.combo, vi: 0, q: 1 }], false, true);
      b.textContent = L("Junto ✓", "Added ✓");
      b.classList.add("is-ok");
      var m = sec.querySelector(".combo__msg");
      m.textContent = comboMsg();
      m.hidden = false;
      if (A().pdpRender) A().pdpRender();
      if (window.NZFX && NZFX.tick) NZFX.tick();
    });
  }
  function campaignCountdown() {
    var C = window.NZCAMPAIGN || {}, end = C.ends ? Date.parse(C.ends) : NaN, box = document.querySelector(".bmt");
    if (!box || isNaN(end) || box.querySelector(".pdp-cd")) return;
    var el = document.createElement("div"); el.className = "pdp-cd"; box.appendChild(el);
    (function tick() {
      var ms = end - Date.now();
      if (ms <= 0) { el.remove(); return; }
      var s = Math.floor(ms / 1000), d = Math.floor(s / 86400), hh = String(Math.floor(s % 86400 / 3600)).padStart(2, "0"), mm = String(Math.floor(s % 3600 / 60)).padStart(2, "0"), ss = String(s % 60).padStart(2, "0");
      el.innerHTML = (NZL.en ? C.label.en : C.label.pt) + " <b>" + (d ? d + "d " : "") + hh + ":" + mm + ":" + ss + "</b>";
      setTimeout(tick, 1000);
    })();
  }
  function pdpEnhance(h) {
    setTimeout(campaignCountdown, 0);
    var app = A().app,
      P = A().P(),
      p = P[h];
    if (!p || !app.querySelector(".pdp")) return;
    var info = app.querySelector(".pdp__info");
    // linha do símbolo por baixo do título
    var sy = symbolOf(h),
      M = MEANING[sy] || MEANING._;
    // ponytail: a referência (Carla) não tem frase entre o preço e as vantagens; o significado fica no acordeão
    void M;
    // correntes em cm
    info.querySelectorAll(".sw button[data-val]").forEach(function (b) {
      var nv = niceVal(b.dataset.val);
      if (nv !== b.dataset.val) b.textContent = nv;
    });
    info.querySelectorAll(".sw").forEach(function (g) {
      var bs = [].slice.call(g.querySelectorAll("button"));
      if (
        bs.length > 1 &&
        bs.every(function (b) {
          return / cm$/.test(b.textContent);
        })
      )
        bs.sort(function (a, b) {
          return parseInt(a.textContent) - parseInt(b.textContent);
        }).forEach(function (b) {
          g.appendChild(b);
        });
    });
    // nomes e valores das opções em PT (só no ecrã; o valor real fica no data-val)
    var LBL = NZL.en ? {} : {
      color: "Cor",
      colour: "Cor",
      "chain length": "Comprimento da corrente",
      length: "Comprimento",
      design: "Modelo",
      size: "Tamanho",
      style: "Estilo",
      "metal color": "Cor do metal",
      material: "Material",
      "ring size": "Tamanho do anel",
    };
    var VAL = NZL.en ? {} : {
      women: "Mulher",
      men: "Homem",
      gold: "Dourado",
      silver: "Prateado",
      black: "Preto",
      "rose gold": "Rosa dourado",
      multicolour: "Multicolor",
      multicolor: "Multicolor",
      white: "Branco",
      blue: "Azul",
      green: "Verde",
      red: "Vermelho",
      pink: "Rosa",
      purple: "Roxo",
    };
    info.querySelectorAll(".opt .lbl").forEach(function (l) {
      var k = l.textContent.trim().toLowerCase();
      if (LBL[k]) l.textContent = LBL[k];
    });
    info.querySelectorAll(".sw button[data-val]").forEach(function (b) {
      var k = b.dataset.val.trim().toLowerCase();
      if (VAL[k]) b.textContent = VAL[k];
    });
    // 45 cm por defeito quando existe
    var b45 = [].slice
      .call(info.querySelectorAll(".sw button[data-val]"))
      .find(function (b) {
        return b.textContent === "45 cm";
      });
    if (b45 && b45.getAttribute("aria-pressed") !== "true")
      setTimeout(function () {
        b45.click();
      }, 0);
    // 3 vantagens com ícone por baixo do preço (como na referência). Material e medidas só quando estão na descrição do produto.
    var mat = material(info), ms = measures(info, p), ticks = [];
    // 3 vantagens com ícone, como na referência (Carla): garantia real de 3 anos, material da ficha do fabricante, pronta a oferecer
    ticks.push([IC.heart, L("Garantia de 3 anos", "3-Year Warranty")]);
    if (mat) ticks.push([IC.steel, mat + L(" (ficha do fabricante)", " (maker's spec sheet)")]);
    var sz = A().size ? A().size(h) : "";
    // ponytail: o botão "Tamanho real" já mostra a medida; não repetir na lista
    if (info.querySelector(".pdp__real")) {}
    else if (sz) ticks.push([IC.ruler, sz]);
    else if (ms.length) ticks.push([IC.ruler, ms.map(function (m) { return m[1]; }).join(" · ")]);
    ticks.push([IC.gift, L("Uma prenda com significado", "A gift that means something")]);
    // liga de zinco: o fabricante não diz que é sem níquel, por isso avisamos com franqueza
    if (/liga de zinco|zinc alloy/i.test((info.querySelector("#pdp-desc") || {}).textContent || "")) ticks.splice(2, 0, [IC.heart, L("Sensível ao níquel? Pergunta-nos antes", "Nickel sensitive? Ask us first")]);
    var tk = info.querySelector("#pdp-ticks");
    if (tk) tk.innerHTML = ticks.slice(0, 3).map(function (t) { return "<li>" + t[0] + "<span>" + esc(t[1]) + "</span></li>"; }).join("");
    // packs com miniaturas (1, 2 ou 3 peças): vê-se o que levas, o preço normal riscado (soma real), o preço com −15% / −20% e quanto poupas
    var P0 = A().P(),
      // um conjunto já tem 2 peças: só se junta mais 1 (sem pack de 3)
      picks = /conjunto|\bset\b/i.test(P0[h].t + " " + h) ? comboPicks(h).slice(0, 1) : comboPicks(h),
      state = { tier: 1, same: !picks.length };
    function vi() {
      return A().pdpVariant ? A().pdpVariant() : 0;
    }
    function lines(t) {
      t = t || state.tier;
      var ls = [{ h: h, vi: vi(), q: 1 }];
      for (var k = 1; k < t; k++) ls.push(!state.same && picks[k - 1] ? { h: picks[k - 1], vi: 0, q: 1 } : { h: h, vi: vi(), q: 1 });
      return ls;
    }
    function merge(ls) {
      var o = [];
      ls.forEach(function (l) {
        var f = o.find(function (x) { return x.h === l.h && x.vi === l.vi; });
        if (f) f.q += l.q; else o.push({ h: l.h, vi: l.vi, q: l.q });
      });
      return o;
    }
    // encomenda real se escolher este pack: carrinho atual + peças do pack, com os mesmos descontos e saldo que a Shopify aplica
    function projected(t) {
      var ls = A().cart().map(function (l) { return { h: l.h, vi: l.vi, q: l.q }; }).filter(function (l) { return P[l.h]; }).concat(lines(t));
      var r = priceLines(ls),
        credit = window.NZSALDO && NZSALDO.has() && r.sub >= NZL.SALDO_MIN ? NZL.SALDO : 0;
      // SALDO5 não acumula com Leva/Buy: a Shopify aplica só o maior
      r.net = credit > r.disc ? r.sub - credit : r.total;
      return r;
    }
    // só peças só de memória (urna, colibri...): o Abraço ao Cão também tem a tag memoria mas é para quem tem o cão vivo
    var tgs = (P0[h] || {}).tg || [],
      box = document.createElement("div"),
      calmP = (tgs.indexOf("memoria") > -1 && tgs.indexOf("caes") < 0 && tgs.indexOf("gatos") < 0) || (function () { try { return !!sessionStorage.getItem("nz-calm"); } catch (e) { return false; } })();
    box.className = "packs" + (calmP ? " packs--calm" : "");
    var KN = { colar: L("Colar", "Necklace"), brinco: L("Brincos", "Earrings"), anel: L("Anel", "Ring"), pulseira: L("Pulseira", "Bracelet"), outro: L("Peça", "Piece") };
    var isSet = /conjunto|\bset\b/i.test(P0[h].t + " " + h);
    function setName(t) {
      var ls = lines(t);
      if (t === 1 && isSet) return /colar|necklace/i.test(P0[h].t) && /brinco|earring/i.test(P0[h].t) ? L("Colar + Brincos", "Necklace + Earrings") : P0[h].t;
      if (ls.every(function (l) { return l.h === h; })) return t + L(" iguais a esta", " the same as this");
      return ls.map(function (l, i) { return i === 0 && isSet ? setName(1) : KN[kind(P0[l.h].t)]; }).join(" + ");
    }
    function render() {
      // linha compacta (referência: caixa de descontos da Carla, cerca de 180 px no total): rádio, miniaturas pequenas lado a lado, nome, preço à direita
      var thumbs = function (t) {
        return lines(t).map(function (l) {
          var q = P0[l.h];
          return '<img src="' + A().img(q.i[0], 120) + '" alt="' + esc(q.t) + '" title="' + esc(q.t) + '" width="38" height="38">';
        }).join("");
      };
      var opt = function (t, name, sub, tag) {
        var r = priceLines(lines(t)), on = state.tier === t, free = projected(t).net >= NZL.FREE;
        return '<div class="pk' + (on ? " on" : "") + '" role="radio" tabindex="' + (on ? 0 : -1) + '" aria-checked="' + on + '" data-tier="' + t + '">' +
          '<span class="pk-dot" aria-hidden="true"></span>' +
          '<div class="pk-th">' + thumbs(t) + "</div>" +
          '<div class="pk-main"><div class="pk-n"><span>' + name + "</span>" + (r.disc ? '<span class="pk-pct">−' + pctFor(r.n) + "%</span>" : "") + "</div>" + (tag ? '<span class="pk-tag">' + tag + "</span>" : "") +
          '<div class="pk-s">' + sub + "</div></div>" + (free && t > 1 ? '<span class="pk-flag">' + L("Portes grátis", "Free delivery") + "</span>" : "") +
          '<div class="pk-p"><b>' + money(r.total) + "</b>" + (r.disc ? "<span><s>" + money(r.sub) + '</s> <em class="pk-save">−' + money(r.disc) + "</em></span>" : "") + "</div></div>";
      };
      var alt = picks.length ? ' <button type="button" class="pk-alt" data-same>' + (state.same ? L("Ver conjuntos a combinar", "See matching sets") : L("Prefiro iguais a esta", "Same piece instead")) + "</button>" : "";
      box.innerHTML =
        '<div class="packs__h"><span>' + (calmP ? L("Para ti e para quem importa", "For you and someone dear") : L("Leva mais, poupa mais", "Buy more, save more")) + "</span><em>" + L("desconto automático no carrinho", "applied in your basket") + "</em></div>" +
        '<div role="radiogroup" aria-label="' + L("Quantas peças", "How many pieces") + '">' +
        (calmP
          ? (isSet ? opt(1, L("1 conjunto", "1 set"), setName(1)) : opt(1, L("1 peça", "1 piece"), L("Só esta peça", "Just this piece"))) +
            opt(2, state.same ? (isSet ? L("2 conjuntos", "2 sets") : L("2 peças", "2 pieces")) : isSet ? L("Conjunto + anel a combinar", "Set + matching ring") : L("O conjunto", "The set"), setName(2)) +
            (state.same || picks.length > 1 ? opt(3, state.same ? (isSet ? L("3 conjuntos", "3 sets") : L("3 peças", "3 pieces")) : L("O conjunto completo", "The full set"), setName(3)) : "")
          : (isSet ? opt(1, L("1 conjunto", "1 set"), setName(1)) : opt(1, L("1 peça", "1 piece"), L("Só esta peça", "Just this piece"))) +
            opt(2, state.same ? (isSet ? L("2 conjuntos", "2 sets") : L("2 peças", "2 pieces")) : isSet ? L("Conjunto + anel a combinar", "Set + matching ring") : L("O conjunto", "The set"), setName(2), L("Recomendado", "Recommended")) +
            (state.same || picks.length > 1 ? opt(3, state.same ? (isSet ? L("3 conjuntos", "3 sets") : L("3 peças", "3 pieces")) : L("O conjunto completo", "The full set"), setName(3)) : "")) +
        "</div>" +
        '<p class="packs__f">' + L("Riscado: preços normais somados. Não acumula.", "Struck-through: normal prices added up. No stacking.") + alt + "</p>";
      var r = priceLines(lines());
      var atc = document.getElementById("atc");
      if (atc && !atc.classList.contains("is-ok"))
        atc.innerHTML = r.n > 1 ? L("Adicionar " + r.n + " peças · ", "Add " + r.n + " pieces · ") + money(r.total) : L("Adicionar ao carrinho", "Add to cart");
      var sb = document.querySelector("#sticky-atc .n b"), on = box.querySelector(".pk.on .pk-n span");
      if (sb) sb.textContent = r.n > 1 && on ? on.textContent + " · " + money(r.total) : money(r.total);
      // preço riscado da barra fixa só faz sentido para 1 peça
      var sw = sb && sb.previousElementSibling; if (sw && sw.tagName === "S") sw.style.display = r.n > 1 ? "none" : "";
      // travão de downgrade: com 1 peça escolhida, uma linha discreta com a poupança real do pack 2 (mesma conta do carrinho)
      var up = document.querySelector(".pk-up");
      if (state.tier === 1 && !calmP && atc) {
        var r2 = priceLines(lines(2)), l2 = lines(2), add = l2[1] && l2[1].h !== h ? kind(P0[l2[1].h].t) : "";
        var OBJ = { colar: L("o colar", "the necklace"), brinco: L("os brincos", "the earrings"), anel: L("o anel", "the ring"), pulseira: L("a pulseira", "the bracelet") };
        if (r2.disc > 0) {
          if (!up) { up = document.createElement("button"); up.type = "button"; up.className = "pk-up"; atc.insertAdjacentElement("afterend", up); up.addEventListener("click", function () { state.tier = 2; render(); }); }
          up.innerHTML = (OBJ[add] ? L("Junta " + OBJ[add], "Add " + OBJ[add]) : L("Leva 2", "Buy 2")) + L(" e poupa <b>", " and save <b>") + money(r2.disc) + "</b> →";
        } else if (up) up.remove();
      } else if (up) up.remove();
    }
    // ordem da Carla: opções, quantidade e botão primeiro; a caixa Leva mais vem logo a seguir ao botão
    box.hidden = true; document.getElementById("atc").insertAdjacentElement("afterend", box);
    render();
    box.addEventListener("click", function (e) {
      var c = e.target.closest(".pk");
      if (e.target.closest("[data-same]")) { state.same = !state.same; render(); return; }
      if (c) { state.tier = +c.dataset.tier; render(); var f = box.querySelector(".pk.on"); if (f) f.focus({ preventScroll: true }); }
    });
    box.addEventListener("keydown", function (e) {
      if (!e.target.closest(".pk") || !/Arrow|Enter| /.test(e.key)) return;
      e.preventDefault();
      if (e.key === "ArrowDown" || e.key === "ArrowRight") state.tier = Math.min(3, state.tier + 1);
      else if (e.key === "ArrowUp" || e.key === "ArrowLeft") state.tier = Math.max(1, state.tier - 1);
      render();
      var f = box.querySelector(".pk.on");
      if (f) f.focus();
    });
    info.addEventListener("click", function (e) {
      if (e.target.closest(".sw button")) setTimeout(render, 0);
    });
    // botões de compra adicionam o pack escolhido
    A().pdpBuy = function () {
      var n = A().pdpQty ? A().pdpQty() : 1;
      return merge(lines()).map(function (l) { return { h: l.h, vi: l.vi, q: l.q * n }; });
    };
    var atc = document.getElementById("atc");
    // bloco emocional + cartão que vira
    var desc = info.querySelector("#pdp-desc");
    info
      .querySelector("#acc-sig > div")
      .insertAdjacentHTML(
        "beforeend",
        '<div class="meaning"><h3>' +
          esc(M[0]) +
          "</h3><p>" +
          esc(M[1]) +
          '</p><button type="button" class="flip" aria-label="' + L("Ver o cartão do significado", "See the meaning card") + '"><span class="flip__in"><span class="flip__f"><b>NUANSE</b><em>' +
          esc(M[2]) +
          '</em><small>' + L("toca para virar", "tap to flip") + '</small></span><span class="flip__b"><b>' + L("O que significa", "What it means") + '</b>' +
          esc(M[1]) +
          "</span></span></button></div>",
      );
    info.querySelector(".flip").addEventListener("click", function () {
      this.classList.toggle("on");
      if (window.NZFX) NZFX.tick();
    });
    // FAQ das clientes 55-75 e dos maridos, logo a seguir
    var faq = NZL.en ? [
      ["Is it safe to buy from a new shop?", "We're a small, new shop run from Portugal. Payment goes through Shopify's secure checkout and we never see your card details. If your order doesn't arrive, we refund you. Questions before you buy: contacto@nuanse.online."],
      ["Is it real silver? Will it tarnish?", "Each piece says what it's made of right under the price, as the maker's spec sheet states. Only pieces marked 925 are solid silver. To make them last, take them off for the shower, the beach and the gym, and store them dry."],
      ["How can I pay?", "By card (Visa, Mastercard, Maestro, Amex), Apple Pay, Google Pay, PayPal or Klarna, on Shopify's secure checkout. You pay in pounds and don't need an account."],
      ["How long does delivery take?", NZL.ETA[0] + " to " + NZL.ETA[1] + " working days in total, tracked. We show the exact dates here and in your basket, and you get a tracking code by email."],
      ["What if I don't like it, or it doesn't fit?", "You have 30 days after it arrives to change your mind, no questions asked, and we refund your original delivery too. Email us and we'll send you the return details. If the piece is faulty or not what you ordered, we cover the return postage as well."],
      ["I'm allergic to nickel. Can I wear it?", "We say what every piece is made of in the description. If you have a strong nickel allergy, email us before you buy and we'll tell you honestly whether this piece is right for you."],
      // 2 perguntas genéricas da Carla (texto dela, aprovado pelo Fran a 18/10)
      ["Can I order a gift for someone?", "Of course! Our products make great gifts. Let us know in your basket if you'd like to include a personalized note with your order."],
      ["What if I need help with my order?", "We're happy to assist! Head over to our Contact Us page, and we'll get back to you quickly to help resolve any issues."],
      ["Can I send it straight to my mum or my daughter?", "Yes. Enter her address at checkout and the order goes straight to her."],
    ] : [
      [
        "É seguro comprar numa loja nova?",
        "Somos uma loja pequena e nova, gerida a partir de Portugal. O pagamento passa pelo checkout seguro da Shopify e nós nunca vemos os dados do teu cartão. Se a encomenda não chegar, devolvemos o dinheiro. Dúvidas antes de comprar: contacto@nuanse.online.",
      ],
      [
        "É prata verdadeira? Escurece?",
        "Cada peça diz de que é feita logo abaixo do preço, segundo a ficha do fabricante. Só as peças marcadas 925 são de prata maciça. Para durarem mais, tira-as no banho, na praia e no ginásio, e guarda-as secas.",
      ],
      [
        "Posso pagar com MB WAY?",
        "Sim. No fim da compra escolhes MB WAY, recebes um pedido no telemóvel e confirmas com o teu código. Também podes pagar por referência Multibanco ou cartão. Não precisas de criar conta.",
      ],
      [
        "Quanto tempo demora?",
        "No total, 9 a 18 dias úteis. Mostramos as datas exatas aqui e no carrinho, e recebes o código de seguimento por email.",
      ],
      [
        "E se não gostar, ou não servir?",
        "Tens 30 dias depois de receberes para mudar de ideias, sem explicações, e devolvemos também os portes de envio. Escreve-nos e mandamos os dados para a devolução. Se a peça tiver defeito ou não for a que encomendaste, pagamos também os portes de devolução.",
      ],
      [
        "Tenho alergia ao níquel. Posso usar?",
        "Dizemos de que é feita cada peça na descrição. Se tens alergia forte ao níquel, escreve-nos antes de comprar e dizemos-te com franqueza se esta peça é para ti.",
      ],
      ["Posso encomendar uma prenda para outra pessoa?", "Claro! As nossas peças são ótimas prendas. Diz-nos no carrinho se quiseres incluir uma mensagem personalizada com a encomenda."],
      ["E se precisar de ajuda com a minha encomenda?", "Estamos cá para ajudar! Vai à nossa página de Contacto e respondemos rapidamente para resolver qualquer problema."],
      [
        "Posso mandar diretamente para a minha mãe ou para a minha filha?",
        "Sim. Escreve a morada dela no checkout e a encomenda segue diretamente para ela.",
      ],
    ];
    info.querySelector("#acc-faq > div").insertAdjacentHTML(
      "beforeend",
      '<div class="pfaq">' +
        faq
          .map(function (q) {
            return (
              "<details><summary>" +
              q[0] +
              "</summary><div>" +
              q[1] +
              "</div></details>"
            );
          })
          .join("") +
        "</div>",
    );
    why(info, p, M);
    // Combina com: 2 a 3 peças da mesma persona; "+ Juntar" adiciona sem sair da página e conta para o Leva 2/3
    A().pdpRender = render;
    // barra fixa: aparece sempre que o botão principal não está no ecrã
    var bar = document.getElementById("sticky-atc");
    if (window._nzObs) window._nzObs.disconnect();
    window._nzObs = new IntersectionObserver(function (en) {
      bar.classList.toggle("on", !en[0].isIntersecting);
    });
    window._nzObs.observe(atc);
    render();
  }

  /* ---------- carrinho ---------- */
  var lastN = null;
  function cartExtras(el, t) {
    var P = A().P(),
      cart = A().cart();
    var n = t.n,
      fill = n >= 4 ? 100 : n === 3 ? 66 : n === 2 ? 33 : n === 1 ? 12 : 0;
    // luto: no percurso de memória ou com uma peça de memória no carrinho, sem tom de promoção
    var calm = document.body.classList.contains("is-calm") || cart.some(function (l) { return P[l.h] && (P[l.h].tg || []).indexOf("memoria") > -1; });
    // texto da referência (Carla): "Add 1 more product to get 15% off"
    var txt = n >= 4 ? L("Tens o desconto máximo: <b>25%</b>", "You've got the maximum discount: <b>25% off</b>")
      : L("Junta mais <b>1</b> peça e tens <b>" + [15, 15, 20, 25][n] + "% de desconto</b>", "Add <b>1</b> more product to get <b>" + [15, 15, 20, 25][n] + "% off</b>");
    var net = t.after - t.credit,
      falta = Math.max(0, NZL.FREE - net);
    var prog =
      '<div class="prog" data-n="' +
      n +
      '"><p class="prog__t">' +
      txt +
      '</p><div class="prog__track"><i style="transform:scaleX(' +
      fill / 100 +
      ')"></i>' +
      [
        [33, L("15% DESC.", "15% OFF"), 2],
        [66, L("20% DESC.", "20% OFF"), 3],
        [100, L("25% DESC.", "25% OFF"), 4],
      ]
        .map(function (x) {
          return (
            '<span class="prog__n' +
            (n >= x[2] ? " on" : "") +
            '" style="left:' +
            x[0] +
            '%" data-node="' +
            x[2] +
            '"><em>' +
            '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M3 12V4h8l10 10-8 8z"/><circle cx="7.5" cy="8.5" r="1.5"/></svg>' +
            "</em><small>" +
            x[1] +
            "</small></span>"
          );
        })
        .join("") +
      '</div><p class="prog__ship">' +
      (falta > 0
        ? L("Faltam " + money(falta) + " para portes grátis.", "You're " + money(falta) + " away from free delivery.")
        : L("Portes grátis ✓", "Free delivery ✓")) +
      "</p></div>";
    // saldo
    var sv = null;
    try {
      sv = JSON.parse(localStorage.getItem("nz-saldo"));
    } catch (e) {}
    var saldo = "";
    // o saldo já aparece nas linhas do total; aqui só o convite para quem ainda não o abriu
    if (!sv && n > 0)
      saldo =
        '<div class="sal">🎁 ' + L("Tens um presente de boas-vindas à tua espera.", "There's a welcome gift waiting for you.") + ' <button type="button" data-saldo-open>' + L("Ver", "See") + '</button></div>';
    // completa o conjunto
    var inCart = cart.map(function (l) {
        return l.h;
      }),
      cross = "";
    for (var i = 0; i < cart.length && !cross; i++) {
      var opts = suggestions(cart[i].h).filter(function (x) {
        return inCart.indexOf(x) < 0 && +P[x].p >= 15 && isMapped(x) && !inCart.some(function (c) { return included(c, x); });
      });
      if (opts.length) {
        var x = opts[0],
          sim = cart
            .map(function (l) {
              return { h: l.h, vi: l.vi, q: l.q };
            })
            .concat([{ h: x, vi: 0, q: 1 }]),
          r = priceLines(sim);
        // formato da Carla (UpCart "You'll love these!"): título ao centro, foto, nome, preço riscado + preço, botão largo
        var cur = NZL.en && NZL.cur ? " " + NZL.cur : "", wx = A().wasOf ? A().wasOf(x, 0) : 0;
        cross =
          '<div class="xs-w"><p class="xs-h">' + L("Vais adorar estas!", "You'll love these!") + '</p><div class="xs"><img src="' +
          A().img(P[x].i[0], 140) +
          '" alt=""><div class="xs__t"><b>' +
          esc(P[x].t.split(/,\s*(?=gift|prenda|presente|keepsake|pet memorial)/i)[0]) +
          "</b><span>" + (wx ? "<s>" + money(wx) + cur + "</s> " : "") +
          money(P[x].p) + cur +
          '</span><button type="button" class="xs__b" data-xs="' +
          x +
          '">' + L("Juntar", "Add") + '</button></div></div></div>';
      }
    }
    var shipSave = t.n && t.ship === 0 ? NZL.SHIP : 0,
      totSave = t.disc + t.credit + shipSave;
    var saveLine =
      totSave > 0
        ? '<div class="save-tot"><b>' + L("Estás a poupar ", "You're saving ") + money(totSave) + "</b></div>"
        : "";
    el.insertAdjacentHTML("afterbegin", prog + saveLine + saldo);
    if (!NZL.en) el.querySelectorAll(".cl small").forEach(function (sm) {
      sm.textContent = sm.textContent
        .replace(/(\d{2})\s*(?:"|”|″|'')/g, function (m0, d) {
          return CHAIN[d] ? CHAIN[d] + " cm" : m0;
        })
        .replace(/\bWomen\b/g, "Mulher")
        .replace(/\bMen\b/g, "Homem")
        .replace(/\bGold\b/g, "Dourado")
        .replace(/\bSilver\b/g, "Prateado")
        .replace(/\bBlack\b/g, "Preto")
        .replace(/\bMulticolou?r\b/g, "Multicolor");
    });
    // caixote do lixo em traço fino cinzento, como a Carla (o SVG da linha fica)
    var f = el.querySelector(".drawer__f");
    if (f) {
      f.insertAdjacentHTML("beforebegin", cross);
      var co = f.querySelector("[data-checkout]");
      if (co) {
        co.innerHTML = ((window.NZCART || {}).co || L("Finalizar compra", "Secure checkout")) + " • " + A().money(A().cartTotals().total) + (NZL.en && NZL.cur ? " " + NZL.cur : ""); // como a Carla: "SECURE CHECKOUT · £20.00 GBP"
        co.insertAdjacentHTML(
          "beforebegin",
          '<p class="co-eta">🚚 ' + A().etaText() + "</p>",
        );
      }
      var ship = f.querySelector(".row:nth-of-type(n)");
    }
    // remover os blocos antigos (barra antiga) se existirem
    el.querySelectorAll(".tiers, .goal").forEach(function (x) {
      x.remove();
    });
    // celebração quando sobe de patamar
    var prev = lastN;
    lastN = n;
    if (prev !== null && n > prev && (n === 2 || (n >= 3 && prev < 3)))
      celebrate(el, n, prev, t, falta === 0);
  }
  document.addEventListener("click", function (e) {
    var x = e.target.closest("[data-xs]");
    if (x) {
      var row = x.closest(".xs");
      if (row && !reduce) row.classList.add("xs--go");
      setTimeout(
        function () {
          A().addLines([{ h: x.dataset.xs, vi: 0, q: 1 }], true);
        },
        reduce ? 0 : 200,
      );
      return;
    }
    if (
      e.target.closest("[data-saldo-open]") &&
      window.NZSALDO &&
      NZSALDO.reveal
    )
      NZSALDO.reveal();
  });
  function celebrate(el, n, prev, t, freeNow) {
    var prog = el.querySelector(".prog");
    if (!prog) return;
    var bar = prog.querySelector(".prog__track i"),
      node = prog.querySelector('[data-node="' + Math.min(3, n) + '"]'),
      txt = prog.querySelector(".prog__t");
    var from = prev >= 2 ? 0.5 : prev === 1 ? 0.12 : 0,
      to = n >= 3 ? 1 : 0.5;
    if (reduce) {
      if (window.NZFX) (n >= 3 ? NZFX.chime : NZFX.tick)();
      return;
    }
    bar.style.transition = "none";
    bar.style.transform = "scaleX(" + from + ")";
    node.classList.remove("on");
    node.querySelector("em").innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M3 12V4h8l10 10-8 8z"/><circle cx="7.5" cy="8.5" r="1.5"/></svg>';
    requestAnimationFrame(function () {
      bar.style.transition = "transform 520ms cubic-bezier(.22,1,.36,1)";
      bar.style.transform = "scaleX(" + to + ")";
    });
    setTimeout(function () {
      node.classList.add("on", "pop");
      node.querySelector("em").innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M3 12V4h8l10 10-8 8z"/><circle cx="7.5" cy="8.5" r="1.5"/></svg>';
      var ring = document.createElement("i");
      ring.className = "prog__ring";
      node.appendChild(ring);
      var count = n >= 3 ? 16 : 10,
        cols = ["#E89B6F", "#47bab0", "#F3D9A4"];
      for (var k = 0; k < count; k++) {
        var d = document.createElement("i"),
          ang = (360 / count) * k + (k % 2 ? 12 : -12),
          dist = 22 + (k % 3) * 8;
        d.className = "prog__p";
        d.style.background = cols[k % 3];
        d.style.setProperty(
          "--x",
          Math.cos((ang * Math.PI) / 180) * dist + "px",
        );
        d.style.setProperty(
          "--y",
          Math.sin((ang * Math.PI) / 180) * dist + "px",
        );
        node.appendChild(d);
        setTimeout(
          function (dd) {
            dd.remove();
          }.bind(null, d),
          700,
        );
      }
      setTimeout(function () {
        ring.remove();
        node.classList.remove("pop");
      }, 700);
      txt.classList.add("swap");
      txt.innerHTML =
        n >= 4 ? L("Tens o desconto máximo: <b>25%</b>", "You've got the maximum discount: <b>25% off</b>")
          : L("Junta mais <b>1</b> peça e tens <b>" + [15, 15, 20, 25][n] + "% de desconto</b>", "Add <b>1</b> more product to get <b>" + [15, 15, 20, 25][n] + "% off</b>");
      if (window.NZFX) (n >= 3 ? NZFX.chime : NZFX.chime)();
      var sv = txt.querySelector(".prog__save");
      if (sv) {
        var t0 = performance.now(),
          goal = t.disc + (t.credit || 0) + (t.n && t.ship === 0 ? NZL.SHIP : 0);
        (function f(tt) {
          var k2 = Math.min(1, (tt - t0) / 700),
            e2 = 1 - Math.pow(1 - k2, 3);
          sv.textContent = L("Poupas ", "You save ") + money(goal * e2);
          if (k2 < 1) requestAnimationFrame(f);
        })(t0);
      }
      if (freeNow)
        setTimeout(function () {
          var ps = prog.querySelector(".prog__ship");
          ps.textContent = L("E os portes ficam por nossa conta ✓", "And delivery is on us ✓");
          ps.classList.add("pop");
          if (window.NZFX) NZFX.tick();
        }, 180);
      prog.classList.add("glow");
      setTimeout(function () {
        prog.classList.remove("glow");
      }, 1900);
    }, 800);
  }

  window.NZOFFER = {
    pdpEnhance: pdpEnhance,
    cartExtras: cartExtras,
    suggestions: suggestions,
    symbolOf: symbolOf,
    setPrev: function (n) {
      lastN = n;
    },
    resetN: function () {
      lastN = null;
    },
  };
})();
